import React from 'react';
import PropTypes from 'prop-types';
import { MiniTab, Form } from '@weezevent/nacre';
import { useController } from 'react-hook-form';
import { FieldErrorMessage } from '../FieldErrorMessage';

export const FormSegmentedControl = ({ name, options }) => {
    const {
        field: { value, onChange },
        fieldState: { error }
    } = useController({
        name
    });

    return (
        <Form.Field>
            <MiniTab
                activeTab={value}
                onTabSelected={tab => onChange(tab.value)}
                panes={options.map(({ text, value, disabled, icon }) => ({
                    label: text,
                    value,
                    disabled,
                    icon
                }))}
            />
            <FieldErrorMessage error={error} />
        </Form.Field>
    );
};

FormSegmentedControl.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.node,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
            disabled: PropTypes.bool,
            icon: PropTypes.string
        })
    )
};
